import React from 'react';

export default () => {
  return (
    <div>
      Community Dashboard
    </div>
  )
}